import {StoreType} from '..';
//types
import {
	IOrganizationAuctionCategory,
	IOrganizationAuctionListResponse,
	IOrganizationAuctionResponse,
	IOrganizationAuctionWonListResponse,
} from '../../utils/types';

export const getAuctionLoaderSelector = (state: StoreType): boolean => state.organizationAuctionStore.isLoading;

export const getAuctionListSelector = (state: StoreType): IOrganizationAuctionListResponse | null =>
	state.organizationAuctionStore.auctionList;

export const getAuctionCategoriesSelector = (state: StoreType): IOrganizationAuctionCategory[] | null =>
	state.organizationAuctionStore.auctionCategories;

export const getAuctionSelector = (state: StoreType): IOrganizationAuctionResponse | null =>
	state.organizationAuctionStore.auction;

export const getAuctionWonListSelector = (state: StoreType): IOrganizationAuctionWonListResponse | null =>
	state.organizationAuctionStore.auctionWonList;
